import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import AddUniversity from "../../components/Admin/AddUni/AddUniversity";
import Amanities from "../../components/Admin/AddUni/Amanities";
import SelectMajors from "../../components/Admin/AddUni/SelectMajors";
import SelectBachelor from "../../components/Admin/AddUni/SelectBachelor";
import Loader from "../../components/Global/Loader";

function AddUni() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoding, setIsLoding] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [formData, setFormData] = useState({
    // university details
    universityCountry: "UK",
    universityName: "",
    abbreviation: "",
    address: "",
    coordinates: "",
    region: "",
    cityTown: "",
    phoneNumber: "",
    emailAddress: "",
    website: "",
    nationalRanking: "",
    internationalRanking: "",
    foundedYear: "",

    // amanaties
    library: false,
    sportsFacilities: false,
    accomodation: false,
    univerityTransport: false,
    nearbyPublicTransport: false,
    studentUnion: false,

    // majors
    masterMajors: [],
    bachelorMajors: [],
  });

  // Add useEffect to fetch university data if ID exists
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    // console.log(id);
    
    if (id) {
      setIsEditing(true);
      fetchUniversityData(id);
    }
  }, []);

  // Move the formData monitoring useEffect outside of fetchUniversityData
  // useEffect(() => {
  //   console.log("Updated formData:", formData);
  // }, [formData]);

  // Function to fetch university data when editing
  const fetchUniversityData = async (id) => {
    try {
      setIsLoding(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/university/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      // Log the response data
      // console.log("API Response:", response.data.data);
      
      // Create the updated data object
      const universityData = {
        ...formData, // Keep default values
        ...response.data.data, // Override with API data
        // Ensure boolean values are properly set for amenities
        library: Boolean(response.data.data.library),
        sportsFacilities: Boolean(response.data.data.sportsFacilities),
        accomodation: Boolean(response.data.data.accomodation),
        univerityTransport: Boolean(response.data.data.univerityTransport),
        nearbyPublicTransport: Boolean(response.data.data.nearbyPublicTransport),
        studentUnion: Boolean(response.data.data.studentUnion),
        // Ensure arrays are properly set
        masterMajors: Array.isArray(response.data.data.masterMajors) 
          ? response.data.data.masterMajors 
          : [],
        bachelorMajors: Array.isArray(response.data.data.bachelorMajors) 
          ? response.data.data.bachelorMajors 
          : []
      };

      // Set the form data
      setFormData(universityData);
      
      // Add debug logging
      // console.log("Updated formData:", universityData);

    } catch (error) {
      // console.error("Error fetching university:", error);
      setError(
        error.response?.data?.message || "Failed to fetch university data"
      );
    } finally {
      setIsLoding(false);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  // console.log("cfvghjk",formData);
  

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    handleAddUniversity();
  };

  // Keep the original handleAddUniversity for both create and update
  const handleAddUniversity = async () => {
    try {
      setIsLoding(true);
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("id");
      // console.log(id);
      
      // Use different endpoint based on whether we're editing or creating
      const url = id 
        ? `${process.env.REACT_APP_BASE_URL}/university/${id}/update`
        : `${process.env.REACT_APP_BASE_URL}/university/new`;
      
      const method = id ? 'patch' : 'post';

      const response = await axios[method](
        url,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response?.data?.success) {
        setSuccess(true);
        // Update success message based on operation
        const message = id ? "University has been updated successfully!" : "University has been added successfully!";
        setSuccessMessage(message);
      }
    } catch (error) {
      // console.error("API Error:", error.response?.data);
      setError(error.response?.data?.message || "Failed to save university");
    } finally {
      setIsLoding(false);
    }
  };

  return (
    <div
      id="main-content"
      className="relative pl-36 mt-16 w-full p-8 bg-[#f4f8fb]"
    >
      {isLoding && <Loader />}
      {success && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
            {/* Modal Content */}
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Success!
            </h2>
            <h4 className="text-sm text-gray-600 mb-6">
              University has been added successfully!
            </h4>
            <div className="flex justify-end space-x-4">
              {/* Proceed Button */}
              <button
                onClick={() => {
                  setSuccess(false);
                  navigate("/admin/universities");
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}
      {error && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
            {/* Modal Content */}
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Something went wrong!
            </h2>
            <h4 className="text-sm text-gray-600 mb-6">
              We encountered an issue while processing your request. Please try
              again later. If the problem persists, contact support.
            </h4>
            <div className="flex justify-end space-x-4">
              {/* Proceed Button */}
              <button
                onClick={() => setError(null)}
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}
      
      <div className="flex flex-wrap space-x-6">
        <div className="px-10 py-6 bg-white rounded shadow-lg w-full">
          <AddUniversity
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
          />
          <Amanities formData={formData} setFormData={setFormData} />
          <SelectMajors formData={formData} setFormData={setFormData} />
          <SelectBachelor formData={formData} setFormData={setFormData} />

          <div className="flex justify-end mt-10 mr-5">
            {/* <!-- Submit Button --> */}
            <div>
              <button
                onClick={handleSubmit}
                className="bg-white text-blue-500 border border-blue-500 px-4 py-2 rounded hover:bg-blue-500 hover:text-white"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUni;
